/* eslint-disable import/prefer-default-export */
import { Common } from '@stockbit/ui';
import styled from 'styled-components';

const { Modal } = Common;

const ModalConfirm = styled(Modal)`
  .ant-modal-header {
    border-radius: 3px 3px 0 0;
  }
  .ant-modal-content {
    border-radius: 3px !important;
  }
  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
  }
  button {
    font-weight: bold;
  }
`;

export { ModalConfirm };
